import { withRouter, Redirect } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import BlockUi from 'react-block-ui';
import { FormGroup, FormControl, ControlLabel, Button, Panel } from 'react-bootstrap';

@inject('userStore')
@withRouter
@observer
export default class Login extends React.Component {
    componentWillMount(){
        this.props.userStore.GetCurrentUserFromCollection();
    }
    handlePropertyChange = e => {
        if (e.target.type === "email" || e.target.type === "text" || e.target.type === "password") {
            this.props.userStore.UpdateProperty(e.target.name, e.target.value);
        }
    }
    render() {
        if (this.props.userStore.CurrentUser === undefined) {
            return (
                <div className="container">
                    <BlockUi tag="div" blocking={this.props.userStore.LoadingUser} message={this.props.userStore.LoginMessage}>
                        <Panel bsStyle="primary">
                            <Panel.Heading>
                                <h4>Login</h4>
                            </Panel.Heading>
                            <Panel.Body>
                                <FormGroup controlId="email" validationState={this.props.userStore.IsValid("Email")}>
                                    <ControlLabel>Email</ControlLabel>
                                    <FormControl type="email" name="Email" value={this.props.userStore.LoginRequest.Email} placeholder="firstname.lastname@sagarsoft.in" onChange={this.handlePropertyChange} />
                                </FormGroup>
                                <FormGroup controlId="password" >
                                    <ControlLabel>Password</ControlLabel>
                                    <FormControl type="password" name="Password" value={this.props.userStore.LoginRequest.Password} placeholder="....." onChange={this.handlePropertyChange} />
                                </FormGroup>
                                <Button type="submit" bsStyle="primary" onClick={() => this.props.userStore.Login()} >Submit</Button>
                            </Panel.Body>
                        </Panel>
                    </BlockUi>
                </div>
            );
        }
        else {
            return (<Redirect to="/" />);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Login.js